import { ga, adjust, pinterest } from 'js/analytics/adapters'

export const trackStartRegistration = () => {
  ga.track('Start Registration')
  adjust.track('Start Registration')
  pinterest.track('lead', {
    lead_type: 'Started signup',
  })
}
